var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseCard',{attrs:{"title":"datos de la categoría","loading":_vm.loading},on:{"save-button-click":_vm.handleSaveButtonClick}},[_c('CategoryForm',{ref:"category-form"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }